(function () {
  'use strict';

  // Variant IDs — re-verify against live store before each campaign launch
  var VARIANTS = {
    bottle: {
      '1L': 46179205284037,
      '2L': 46179206365381,
      '4L': 46179200860357,
      '6L': 46179203023045
    },
    tray: {
      '1L': 46299413643461,
      '2L': 46299413643461,
      '4L': 44462880817349,
      '6L': 44462880817349
    },
    cup: {
      '1L': 45128518205637
    },
    sling: {
      '4L': 45106445910213,
      '6L': 45106908168389
    },
    grip1L: {
      'Black':     44616121778373,
      'Charcoal':  44616121811141,
      'Green':     44616121843909,
      'Navy':      45311215632581,
      'Almond':    45311215665349,
      'White':     45311215698117,
      'Latte':     45311215730885,
      'Seabreeze': 45311215763653,
      'Blue':      44616121876677,
      'Pistachio': 45311287591109,
      'Butter':    45761537769669,
      'Plum':      45761537802437,
      'Stone':     45761537835205,
      'Coral':     46147240788165
    },
    grip2L: {
      'Black':     44616122826949,
      'Charcoal':  44616122859717,
      'Navy':      45311221465285,
      'Almond':    45311221498053,
      'White':     45311221530821,
      'Latte':     45311221563589,
      'Seabreeze': 45311221596357,
      'Blue':      44616122925253,
      'Pistachio': 45311286804677,
      'Green':     44616122892485,
      'Butter':    45761540653253,
      'Plum':      45761540686021,
      'Stone':     45761540718789
    }
  };

  function buildItems(s) {
    var items = [];

    var bottleId = VARIANTS.bottle[s.size];
    if (bottleId) items.push({ id: bottleId, quantity: 1 });

    if (s.grip && (s.size === '1L' || s.size === '2L')) {
      var gripMap = s.size === '1L' ? VARIANTS.grip1L : VARIANTS.grip2L;
      var gripId = gripMap[s.gripColour];
      if (gripId) items.push({ id: gripId, quantity: 1 });
    }

    if (s.tray) {
      var trayId = VARIANTS.tray[s.size];
      if (trayId) items.push({ id: trayId, quantity: 1 });
    }

    if (s.cup && s.size === '1L') {
      items.push({ id: VARIANTS.cup['1L'], quantity: 1 });
    }

    if (s.sling && (s.size === '4L' || s.size === '6L')) {
      var slingId = VARIANTS.sling[s.size];
      if (slingId) items.push({ id: slingId, quantity: 1 });
    }

    return items;
  }

  window.lpAddToCart = function (s, btn) {
    var items = buildItems(s);
    if (!items.length) return;

    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart_add_failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = 'Added. Nice one.';
        // cart_drawer.js fetch monkey-patch opens the drawer automatically
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add my setup to cart';
      });
  };
})();
